export default __webpack_public_path__ + "static/media/image.45309488.jpg";